import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import axios from 'axios';
import EmptyLayout from './layouts/EmptyLayout.vue'
import MainLayout from './layouts/MainLayout.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueConfirmDialog from 'vue-confirm-dialog'
import i18n from './plugins/i18n'

axios.defaults.baseURL = 'https://seemeworking.com:3337/';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

Vue.config.productionTip = false
Vue.component('empty-layout', EmptyLayout)
Vue.component('main-layout', MainLayout)
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('pulse-loader', require('vue-spinner/src/PulseLoader.vue'));
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
